import { Component, OnInit } from '@angular/core';
import { IServiceItem } from 'src/app/models/service-item.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-calibrations',
  templateUrl: './calibrations.component.html',
  styleUrls: ['./calibrations.component.scss']
})
export class CalibrationsComponent implements OnInit {
  private bannerCount = 0;
  private imageUrls: string[];

  serviceItems: IServiceItem[];
  industries: IServiceItem[];
  backgroundImage: string;
  bannerTagTitle: string;
  bannerTagLine1: string;
  bannerTagLine2: string;

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Calibraciones - CCCISA');
    this.serviceItems = [
      {
        title: 'Calibración',
        // tslint:disable-next-line: max-line-length
        description: 'Operación que bajo condiciones especificadas establece, en una primera etapa, una relación entre los valores y sus incertidumbres de medida asociadas obtenidas a partir de los patrones de medida',
        icon: '/assets/img/calibrations/calib.svg'
      },
      {
        title: 'Calificación',
        // tslint:disable-next-line: max-line-length
        description: 'Proceso total de aseguramiento de que un instrumento es apropiado para el uso propuesto y que su funcionamiento está de acuerdo a las especificaciones establecidas por el usuario y el proveedor.',
        icon: '/assets/img/calibrations/calif.svg'
      },
      {
        title: 'Ensayo',
        // tslint:disable-next-line: max-line-length
        description: 'Operación técnica que consiste en la determinación de una o más características de un determinado equipo de acuerdo con un procedimiento especificado.',
        icon: '/assets/img/calibrations/ensayo.svg'
      },
    ];

    this.industries = [
      { title: 'Metal Mecánica', icon: '/assets/img/calibrations/metal_mecanica.svg' },
      { title: 'Farmacéutica', icon: '/assets/img/calibrations/farma.svg' },
      { title: 'Alimenticia', icon: '/assets/img/calibrations/alimenticia.svg' },
      { title: 'Aeronáutica', icon: '/assets/img/calibrations/aero.svg' },
      { title: 'Automotriz', icon: '/assets/img/calibrations/auto.svg' },
      { title: 'Inyección Plástica', icon: '/assets/img/calibrations/plastica.svg' },
      { title: 'Sector salud', icon: '/assets/img/calibrations/sector_salud.svg' },
      { title: 'Logística', icon: '/assets/img/calibrations/logistica.svg' }
    ];

    this.imageUrls = [
      '/assets/img/calibrations/banner1.png',
      '/assets/img/calibrations/banner2.png',
      '/assets/img/calibrations/banner3.png'
    ];

    this.backgroundImage = `url(${this.imageUrls[this.bannerCount]})`;
    this.bannerTagTitle = 'Ensayo';
    this.bannerTagLine1 = 'Metal mecánica';
    this.bannerTagLine2 = '(Prueba de válvulas)';
    this.startBanner();
  }

  startBanner() {
    setTimeout(() => {
      this.bannerCount = this.bannerCount >= this.imageUrls.length - 1 ? 0 : this.bannerCount += 1;

      switch (this.bannerCount) {
        case 0:
          this.bannerTagTitle = 'Ensayo';
          this.bannerTagLine1 = 'Metal mecánica (Prueba de válvulas)';
          this.bannerTagLine2 = 'Fuentes Fijas';
          break;
        case 1:
          this.bannerTagTitle = 'Calibración';
          this.bannerTagLine1 = 'Temperatura, humedad, presión, masa, óptica';
          this.bannerTagLine2 = 'Densidad, dimensional, volumen, mediciones especiales';
          break;
        case 2:
            this.bannerTagTitle = 'Calificación';
            this.bannerTagLine1 = 'Calificación de equipos';
            this.bannerTagLine2 = 'Calificación de EIMAs';
            break;
      }

      this.backgroundImage = `url(${this.imageUrls[this.bannerCount]})`;
      this.startBanner();
    }, 3000);
  }
}
